export const gdpr = {
  routes: [
    {
      path: "/department",
      component: () => import("../organization-department-view"),
    },
  ],
};

export const workspace = {
  routes: [
    {
      path: "/workspace/library/department",
      component: () => import("../workspace-library-department-view"),
    },
    {
      path: "/workspace/library/department-category",
      component: () => import("../workspace-library-department-category-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/department",
      component: () => import("../management-library-department-view"),
    },
    {
      path: "/management/department-category",
      component: () => import("../management-library-department-category-view"),
    },
  ],
};
